const e = "_headerRoot_wx9d3_1", d = "_hasDivider_wx9d3_13", t = "_isEmptyHeader_wx9d3_17", s = {
  headerRoot: e,
  hasDivider: d,
  isEmptyHeader: t
};
export {
  s as default,
  d as hasDivider,
  e as headerRoot,
  t as isEmptyHeader
};
//# sourceMappingURL=index.es5614.js.map
